export default "__VITE_ASSET__KOXtgXjg__"